import React from 'react';
import { css } from '@ts-tools/emotion';
import { useSelector } from 'react-redux';
import { selectSession } from '../page/sessionSlice';
import SearchBoxMagnifyingGlass from '../SearchBoxMagnifyingGlass';
import { Alerts } from './Alerts';
import Link from 'next/link';
import { palette } from '@leafygreen-ui/palette';
import { SUPPORT_POLICY_URL } from '../../constants/urls';
import { Nav as TSNav } from "@ts-tools/nav";
/**
 * The approach used in this component shows how to built a sign in and sign out
 * component that works on pages which support both client and server side
 * rendering, and avoids any flash incorrect content on initial page load.
 **/
const Nav = () => {
  const loading = false;
  const session = useSelector(selectSession);

  const linkText = css`
    text-decoration: none;
    color: ${palette.gray.dark3};
    margin-right: 16px;
    padding: 4px;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      top: calc(100% + 4px);
      left: 0;
      right: 0;
      opacity: 0;
      transform: scale(0.8, 1);
      transition: 150ms ease-in-out;
      height: 3px;
      border-radius: 200px;
    }

    &:hover {
      text-decoration: none;
      &:after {
        opacity: 1;
        transform: scale(1);
        background-color: ${palette.gray.light2};
      }
    }
  `;

  return (
    <TSNav
      siteTitle={<span>Support</span>}
      session={session}
      bannerSection={session ? <Alerts /> : null}
      middleSection={
        <div className="nav-search-mag">
          {session?.acl?.acl_canViewKB && (
            <SearchBoxMagnifyingGlass></SearchBoxMagnifyingGlass>
          )}
          {session && session.customer && (
            <>
              <Link href={'/cases'}>
                <a className={linkText}>Cases</a>
              </Link>

              <Link href={'/projects'}>
                <a className={linkText}>Projects &amp; Users</a>
              </Link>
            </>
          )}

          {session?.acl?.acl_canViewKB && (
            <Link href={'/find'}>
              <a className={linkText}>Knowledge Base</a>
            </Link>
          )}
          <Link href={SUPPORT_POLICY_URL}>
            <a className={linkText}>Support Policy</a>
          </Link>
        </div>
      }
    />
  );
};

export default Nav;
